// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2cPob","row":"styles_row__WTNrX"};